<template>
  <div class="blocco" v-if="useAuthStore.getters.isAuthenticated">

    <div class="header-wrapper">
      <img :src="`/ajax/proxy-image.php?url=${encodeURIComponent(imgHeader)}`" class="header-img" id="img-pdf-print-qrcode" />

      <div class="calendario">
        <div class="col-md-12">

          <div class="header-content">

            <!-- LEFT: DATE BLOCK -->
            <div class="date-container">
              <div>

                <!-- EVENT TYPE -->
                <div class="event-type" :style="{ backgroundColor: dominantColor, color: textContrastColor }">
                  {{ fullEventData.event_type?.name }}
                </div>

                <!-- DATE BOX -->
                <div class="event-date" :style="{ backgroundColor: lighterColor, color: textContrastColor }">
                  <div class="day">{{ eventDay() }}</div>
                  <div class="month">{{ eventMonth() }}</div>
                </div>

              </div>
            </div>

            <!-- RIGHT: EVENT INFO -->
            <div class="event-info">

              <div class="event-name">
                {{ fullEventData.name }}
              </div>

              <div class="event-sub-info">

                <div class="icon-container">
                  <div>
                    <div class="icon-content">
                      <i class="material-icons">location_on</i>
                    </div>
                  </div>
                  {{ fullEventData.location }}
                </div>

                <div class="icon-container">
                  <div>
                    <div class="icon-content">
                      <i class="material-icons">people_outline</i>
                    </div>
                  </div>
                  {{ fullEventData.size_guest }}
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

    <button

  class="event-local-menu-btn hide-on-large-only"
  @click="isLocalMenuOpen = true"
  type="button"
>
  <i class="material-icons">menu</i>
</button>

    <div class="body-border corpo-menu-event">
      <div class="row">
        <div class="col s12 m12 l12 xl12 align-center hide-on-med-and-down">

          <!-- GO BACK -->

          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('title.list.event.page')" @click="goBack">
            <i class="material-icons">today</i>
          </button>

          <!-- LISTA OSPITI -->
          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('btn.link.menu.event.list.pax')" @click="goListPax"
            :disabled="isListPaxButtonDisabled">
            <i class="material-icons">people</i>
          </button>

          <!-- MODIFICA EVENTO -->
          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('btn.menu.event.modify')" @click="editEvent"
            :disabled="isEditEventButtonDisabled">
            <i class="material-icons">mode_edit</i>
          </button>

          <!-- CUSTOMIZE EVENTO -->
          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('title.customize.page')" @click="customizeEvent"
            :disabled="isCustomizePageDisabled">
            <i class="material-icons">photo_library</i>
          </button>

          <!-- CUSTOM LABELS -->
          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('guest.list.fields.selection')" @click="customizeLabels"
            :disabled="isCustomizeLabels">
            <i class="material-icons">text_fields</i>
          </button>

          <!-- TAVOLI -->
          <button v-if="hasTable" class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('event.card.title.gestione.tavoli')" @click="listRooms">
            <i class="material-icons">local_dining</i>
          </button>

          <!-- EMAIL -->
          <button v-if="hasMail" class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('event.card.title.gestione.email')" @click="listEmail"
            :disabled="isEmail">
            <i class="material-icons">email</i>
          </button>

          <button v-if="hasMail" class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('pagina.email.editor.email')" @click="editEmail"
            :disabled="isEditEmail">
            <i class="material-icons">developer_board</i>
          </button>

          <!-- QRCODE -->
          <button class="btn-small red ml-2 btn-pad redtooltip"
            v-red-tooltip="translation.getters.traduzione('bt.qrcode.tooleti')" @click="qrcodepage"
            :disabled="isQrcodePage">
            <i class="material-symbols-outlined">qr_code</i>
          </button>

        </div>
      </div>
    </div>

    <div
  class="event-local-drawer"
  :class="{ open: isLocalMenuOpen }"
>
  <button class="drawer-close" @click="isLocalMenuOpen = false">
    <i class="material-icons">close</i>
  </button>

  <button class="drawer-item" @click="goBackAndClose">
    <i class="material-icons">today</i>
    {{ translation.getters.traduzione('title.list.event.page') }}
  </button>

  <button class="drawer-item" @click="goListPaxAndClose">
    <i class="material-icons">people</i>
    {{ translation.getters.traduzione('btn.link.menu.event.list.pax') }}
  </button>

  <button class="drawer-item" @click="editEventAndClose">
    <i class="material-icons">mode_edit</i>
    {{ translation.getters.traduzione('btn.menu.event.modify') }}
  </button>

  <button class="drawer-item" @click="customizeEventAndClose">
    <i class="material-icons">photo_library</i>
    {{ translation.getters.traduzione('title.customize.page') }}
  </button>

  <button class="drawer-item" @click="customizeLabelsAndClose">
    <i class="material-icons">text_fields</i>
    {{ translation.getters.traduzione('guest.list.fields.selection') }}
  </button>

  <button v-if="hasTable" class="drawer-item" @click="listRoomsAndClose">
    <i class="material-icons">local_dining</i>
    {{ translation.getters.traduzione('event.card.title.gestione.tavoli') }}
  </button>

  <button v-if="hasMail" class="drawer-item" @click="listEmailAndClose">
    <i class="material-icons">email</i>
    {{ translation.getters.traduzione('event.card.title.gestione.email') }}
  </button>

  <button v-if="hasMail" class="drawer-item" @click="editEmailAndClose">
    <i class="material-icons">developer_board</i>
    {{ translation.getters.traduzione('pagina.email.editor.email') }}
  </button>

  <button class="drawer-item" @click="qrcodepageAndClose">
    <i class="material-icons">qr_code</i>
    {{ translation.getters.traduzione('bt.qrcode.tooleti') }}
  </button>
</div>

  </div>
</template>

<script>
import eventSetting from '@/store/eventSettings.js'
import translationStore from '@/store/translations'
import ColorThief from 'colorthief'
import authStore from '@/store/authStore.js'

export default {
  name: 'evetMenu',
  data () {
    return {
      translation: translationStore,
      dominantColor: null,
      lighterColor: null,
      darkerColor: null,
      textContrastColor: null,
      useAuthStore: authStore,
      isLocalMenuOpen: false

    }
  },

  props: {
    imgHeader: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.loadDominant()
  },

  methods: {

    goBackAndClose () { this.isLocalMenuOpen = false; this.goBack() },
    goListPaxAndClose () { this.isLocalMenuOpen = false; this.goListPax() },
    editEventAndClose () { this.isLocalMenuOpen = false; this.editEvent() },
    customizeEventAndClose () { this.isLocalMenuOpen = false; this.customizeEvent() },
    customizeLabelsAndClose () { this.isLocalMenuOpen = false; this.customizeLabels() },
    listRoomsAndClose () { this.isLocalMenuOpen = false; this.listRooms() },
    listEmailAndClose () { this.isLocalMenuOpen = false; this.listEmail() },
    editEmailAndClose () { this.isLocalMenuOpen = false; this.editEmail() },
    qrcodepageAndClose () { this.isLocalMenuOpen = false; this.qrcodepage() },

    eventDay () {
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'
      let raw = this.fullEventData.event_date_start
      if (!raw) return ''

      if (raw.includes('/')) {
        const parts = raw.split('/')
        raw = `${parts[2]}-${parts[1]}-${parts[0]}`
      }

      return this.$formatEventDate(raw, 'DD', tz)
    },

    eventMonth () {
      const tz = this.fullEventData?.timezone?.timezone_name || 'UTC'
      let raw = this.fullEventData.event_date_start
      if (!raw) return ''

      // se arriva nel formato 26/11/2025 → lo converto in ISO
      if (raw.includes('/')) {
        const parts = raw.split('/')
        raw = `${parts[2]}-${parts[1]}-${parts[0]}`
      }

      const monthNum = this.$formatEventDate(raw, 'MM', tz)

      const names = [
        this.translation.getters.traduzione('monthsShort.jen'),
        this.translation.getters.traduzione('monthsShort.feb'),
        this.translation.getters.traduzione('monthsShort.mar'),
        this.translation.getters.traduzione('monthsShort.apr'),
        this.translation.getters.traduzione('monthsShort.may'),
        this.translation.getters.traduzione('monthsShort.jun'),
        this.translation.getters.traduzione('monthsShort.jul'),
        this.translation.getters.traduzione('monthsShort.ago'),
        this.translation.getters.traduzione('monthsShort.set'),
        this.translation.getters.traduzione('monthsShort.ott'),
        this.translation.getters.traduzione('monthsShort.nov'),
        this.translation.getters.traduzione('monthsShort.dic')
      ]

      return names[Number(monthNum) - 1] || ''
    },

    getTextContrastColor (rgbString) {
      const [r, g, b] = rgbString.match(/\d+/g).map(Number)

      // luminanza percepita (W3C)
      const luminance = (0.299 * r) + (0.587 * g) + (0.114 * b)

      // soglia perfetta per UX (≈ 150)
      return luminance > 150 ? '#000000' : '#FFFFFF'
    },

    rgbToHsl (r, g, b) {
      r /= 255; g /= 255; b /= 255

      const max = Math.max(r, g, b)
      const min = Math.min(r, g, b)
      let h; let s; const l = (max + min) / 2

      if (max === min) {
        h = s = 0 // grigio
      } else {
        const d = max - min
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

        switch (max) {
          case r: h = ((g - b) / d + (g < b ? 6 : 0)); break
          case g: h = ((b - r) / d + 2); break
          case b: h = ((r - g) / d + 4); break
        }
        h /= 6
      }

      return { h, s, l }
    },

    hslToRgb (h, s, l) {
      let r, g, b

      if (s === 0) {
        r = g = b = l // grigio
      } else {
        const hue2rgb = (p, q, t) => {
          if (t < 0) t += 1
          if (t > 1) t -= 1
          if (t < 1 / 6) return p + (q - p) * 6 * t
          if (t < 1 / 2) return q
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
          return p
        }

        const q = l < 0.5 ? l * (1 + s) : (l + s - l * s)
        const p = 2 * l - q

        r = hue2rgb(p, q, h + 1 / 3)
        g = hue2rgb(p, q, h)
        b = hue2rgb(p, q, h - 1 / 3)
      }

      return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`
    },

    lightenColor (rgbString, amount = 0.25) {
      const rgb = rgbString.match(/\d+/g).map(Number)
      const { h, s, l } = this.rgbToHsl(rgb[0], rgb[1], rgb[2])

      const newL = Math.min(1, l + amount)
      return this.hslToRgb(h, s, newL)
    },

    darkenColor (rgbString, amount = 0.25) {
      const rgb = rgbString.match(/\d+/g).map(Number)
      const { h, s, l } = this.rgbToHsl(rgb[0], rgb[1], rgb[2])

      const newL = Math.max(0, l - amount)
      return this.hslToRgb(h, s, newL)
    },

    async loadDominant () {
      if (!this.imgHeader) return

      const proxiedURL = `/ajax/proxy-image.php?url=${encodeURIComponent(this.imgHeader)}`

      try {
        const color = await this.getDominantColorFromURL(proxiedURL)
        this.dominantColor = color
      } catch (err) {
        console.error('DominantColor ERROR:', err)
        this.dominantColor = 'rgb(40,40,40)'
      }

      this.lighterColor = this.lightenColor(this.dominantColor, 0.30)
      this.darkerColor = this.darkenColor(this.dominantColor, 0.30)
      this.textContrastColor = this.getTextContrastColor(this.dominantColor)
    },

    async getDominantColorFromURL (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.src = url

        img.onload = () => {
          try {
            const thief = new ColorThief()
            const rgb = thief.getColor(img)
            resolve(`rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`)
          } catch (e) {
            reject(new Error(e)) // <-- FIX QUI
          }
        }

        img.onerror = () => {
          reject(new Error('Failed to load image for dominant color')) // <-- FIX QUI
        }
      })
    },

    computeDominant (data) {
      const colorCount = {}
      let maxCount = 0
      let dominant = [0, 0, 0]

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i]
        const g = data[i + 1]
        const b = data[i + 2]

        const key = `${r},${g},${b}`

        colorCount[key] = (colorCount[key] || 0) + 1

        if (colorCount[key] > maxCount) {
          maxCount = colorCount[key]
          dominant = [r, g, b]
        }
      }
      return dominant
    },

    /* ----------- NAVIGAZIONE ----------- */
    goBack () {
      eventSetting.dispatch('showHeaderChange', false)
      this.$router.push('/list-events')
    },

    listEmail () {
      eventSetting.dispatch('showHeaderChange', true)
      this.$router.push('/list-email')
    },

    editEmail () {
      eventSetting.dispatch('showHeaderChange', true)
      this.$router.push('/edit-email')
    },

    editEvent () {
      this.$router.push('/modify-event')
    },
    goListPax () {
      this.$router.push('/list-guests')
    },
    customizeEvent () {
      this.$router.push('/customize-event')
    },
    customizeLabels () {
      this.$router.push('/customize-label')
    },
    listRooms () {
      this.$router.push('/list-rooms')
    },
    qrcodepage () {
      this.$router.push('/qrcode-events')
    }
  },

  computed: {

    isSubmenu () {
      return (
        this.isEditEventButtonDisabled &&
    this.isListPaxButtonDisabled &&
    this.isCustomizePageDisabled &&
    this.isEmail &&
    this.isEditEmail &&
    this.isCustomizeLabels &&
    this.isQrcodePage
      )
    },

    isEditEventButtonDisabled () {
      return this.$route.name === 'modifyevent'
    },
    isListPaxButtonDisabled () {
      return this.$route.name === 'listguests'
    },
    isCustomizePageDisabled () {
      return this.$route.name === 'customizeevent'
    },
    isEmail () {
      return ['listmail'].includes(this.$route.name)
    },

    isEditEmail () {
      return ['editemail'].includes(this.$route.name)
    },

    isCustomizeLabels () {
      return this.$route.name === 'customizelabels'
    },
    isQrcodePage () {
      return this.$route.name === 'qrcodeevents'
    },
    fullEventData () {
      return eventSetting.getters?.eventModel ?? {}
    },
    hasMail () {
      return this.fullEventData.has_mailer || false
    },
    hasTable () {
      return this.fullEventData.has_table || false
    }
  }
}
</script>

<style>

  /* ===== LOCAL EVENT DRAWER (SAFE) ===== */
/* =========================================================
   LOCAL EVENT MENU (BUTTON + DRAWER)
   ========================================================= */

/* Bottone menu locale (mobile / tablet) */
.event-local-menu-btn {
 float: right;
    margin-right: 8%;
  top: 16px;
  right: 16px;

  z-index: 1200; /* sopra header, overlay e calendario */

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.65);
  border: none;
  border-radius: 12px;
  padding: 8px 14px;
  color: #fff;
}

.event-local-menu-btn i {
  font-size: 30px;
}

/* Drawer laterale */
.event-local-drawer {
  position: fixed;
  top: 0;
  right: 0;

  width: 280px;
  max-width: 80vw;
  height: 100vh;

  background: #111;
  padding: 16px;

  transform: translateX(100%);
  transition: transform 0.25s ease;
  z-index: 1300;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.event-local-drawer.open {
  transform: translateX(0);
}

.drawer-close {
  background: none;
  border: none;
  color: #fff;
  margin-bottom: 12px;
}

.drawer-item {
  width: 100%;
  background: none;
  border: none;
  color: #fff;

  display: flex;
  align-items: center;
  gap: 10px;

  padding: 10px;
  text-align: left;
  border-radius: 8px;
}

.drawer-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* Desktop: menu locale disattivato */
@media (min-width: 1025px) {
  .event-local-menu-btn,
  .event-local-drawer {
    display: none !important;
  }
}

/* =========================================================
   BASE LAYOUT
   ========================================================= */

.blocco {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Wrapper di riferimento per overlay */
.header-wrapper {
  position: relative;
  width: 100%;
}

.header-img {
  width: 100%;
  display: block;
}

/* =========================================================
   CALENDARIO / OVERLAY (DESKTOP BASE)
   ========================================================= */

.calendario {
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translateY(-50%);

  z-index: 2;
  pointer-events: none;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;

  pointer-events: auto;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);

  padding: 50px;
  border-radius: 35px;
}

/* =========================================================
   DATE BLOCK
   ========================================================= */

.date-container {
  flex-shrink: 0;
}

.event-type {
  padding: 4px 10px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
}

.event-date {
  padding: 10px 18px;
  text-align: center;
}

.event-date .day {
  font-size: 30px;
  font-weight: 700;
  line-height: 28px;
}

.event-date .month {
  font-size: 32px;
  text-transform: uppercase;
}

/* =========================================================
   EVENT INFO
   ========================================================= */

.event-info {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.event-name {
  font-size: 36px;
  font-weight: 700;
}

.event-sub-info {
  display: flex;
  gap: 20px;
  margin-top: 10px;
  font-size: 14px;
}

.icon-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

.icon-content i {
  font-size: 18px;
  opacity: 0.8;
}

/* =========================================================
   PHONE (≤ 767px)
   → stesso layout, SOLO SCALING
   ========================================================= */

@media (max-width: 767px) {

  .header-img {
    height: 180px;
    object-fit: cover;
  }

  .calendario {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .header-content {
    transform: scale(0.62);
    transform-origin: center center;
    max-width: 92vw;
  }
}

/* =========================================================
   TABLET (768px – 1024px)
   → stesso layout, scaling leggero
   ========================================================= */

@media (min-width: 768px) and (max-width: 1024px) {

  .calendario {
    left: 35%;
    transform: translate(-50%, -50%);
  }

  .header-content {
    transform: scale(0.78);
    transform-origin: center center;
    max-width: 86vw;
  }
}

</style>
